
  Vue.component('widget-seo-job', {
    props: {
      id: { type: String, required: true },
      updateCount: { type: Function }
    },
    data() {
      return {
        consent: false,
        confirmed: false,
        error: false,
        loading: false,
        checkStatus: true,
        jobProfiles: [],
        selectedProfile: -1,
        selectedProfiles: [],
        initialSkills: [0, 1, 2, 3, 4],
        selectedSkills: {},
        extraProfile: null,
        searchProfile: '',
        value: '',
        idUser: null
      }
    },
    pinia: Vue.pinia,
    template: '#widget-seo-job',
    computed: {
      ...Pinia.mapState(useSeoJobStore, {
        seoJobStatus: store => store.seoJobStatus,
        seoJobUsageCount: store => store.seoJobUsageCount,
        seoJobRemainingCount: store => store.seoJobRemainingCount,
        seoJobAvailableCount: store => store.seoJobAvailableCount
      })
    },
    watch: {
      seoJobUsageCount(val, old) {
        if (val === 0) {
          this.removeProcessButton()
        } else if (old === 0 && val > 0) {
          this.addProcessButton()
        }
      },
      confirmed(val) {
        this.value = this.getValue(val)
        if (val) {
          this.removeProcessButton(true)
        }
      }
    },
    methods: {
      ...Pinia.mapActions(useSeoJobStore, ['geSeoJobStatus', 'updatetSeoJobUsageCount']),
      selectedJobProfiles(id) {
        return this.jobProfiles[id]
      },
      getValue(confirmed, skill) {
        let value = ''
        if (confirmed) {
          value = JSON.stringify({
            jobProfiles: this.jobProfiles,
            selectedProfiles: this.selectedProfiles,
            selectedSkills: skill ?? this.selectedSkills
          })
        }
        return value
      },
      XXXselectProfile(index) {
        if (this.confirmed) return
        this.selectedProfile = index
        this.selectedSkills = [...this.initialSkills]
      },
      selectProfile(number) {
        if (this.confirmed) return

        const index = this.selectedProfiles.indexOf(number)
        if (index !== -1) {
          this.selectedProfiles.splice(index, 1)
          delete this.selectedSkills[number]
          this.updatetSeoJobUsageCount(-1)
        } else if (this.seoJobAvailableCount === 1) {
          this.selectedSkills = {}
          this.selectedProfiles = [number]
          this.selectedSkills[number] = [...this.initialSkills]
          if (this.seoJobRemainingCount === 1) {
            this.updatetSeoJobUsageCount(1)
          }
        } else if (this.seoJobRemainingCount > 0) {
          this.selectedProfiles.push(number)
          this.selectedSkills[number] = [...this.initialSkills]
          this.updatetSeoJobUsageCount(1)
        }
      },
      removeProcessButton(enableNext) {
        $('.btn-new-next').show()
        if (enableNext) $('.btn-new-next').prop('disabled', false)
        $('#seoJobProcess').remove()
      },
      addProcessButton() {
        const self = this
        $('.btn-new-next').hide()
        const button =
          '<button id="seoJobProcess" type="button" class="btn-new btn-gradient btn-bg-white py-3 px-4" ><span >Procedi</span></button>'
        $('#widget-pager-next-button').append(button)
        $('#seoJobProcess').on('click', event => {
          event.preventDefault()
          self.confirmed = true
        })
      },
      updateItemSkills(profile, skills) {
        this.selectedSkills[profile] = skills
        this.value = this.getValue(this.confirmed, this.selectedSkills)
      },
      async getStatus() {
        await this.geSeoJobStatus(this.idUser)
        if (this.seoJobStatus.FreeLimit - this.seoJobStatus.FreeUsed === 0) {
          $('.btn-new-next').prop('disabled', false).click()
        } else {
          this.checkStatus = false
        }
      },
      getProfiles() {
        this.error = false
        this.consent = true
        this.loading = true
        axios
          .post(`/api/v1/widget/seo-job/profiles-with-skills`, { idUser: this.idUser })
          .then(response => {
            const { data } = response
            this.jobProfiles = data
          })
          .catch(error => {
            this.error = true
          })
          .finally(() => {
            this.loading = false
          })
      },
      getSkills() {
        this.loading = true
        axios
          .post(`/api/v1/widget/seo-job/skills-by-profile`, { jobProfile: this.searchProfile, idUser: this.idUser })
          .then(response => {
            const { data } = response
            this.extraProfile = data
            this.jobProfiles.push(data)
          })
          .catch(error => {
            this.error = true
          })
          .finally(() => {
            this.loading = false
          })
      },
      ottieniIniziali(testo) {
        const parole = testo.split(/\s+/).filter(stringa => stringa.length > 2)

        // Inizializza una stringa per contenere le iniziali
        let iniziali = ''

        if (parole.length > 1)
          for (let i = 0; i < Math.min(2, parole.length); i++) {
            iniziali += parole[i].substring(0, 1)
          }
        iniziali = iniziali.length < 2 ? parole[0].substring(0, 2) : iniziali

        return iniziali
      },
      goToEnd() {
        this.confirmed = true
      }
    },
    mounted() {
      this.idUser = $('#hfNewUserId').val()
      $('.btn-new-next').prop('disabled', true)
      this.getStatus()
    }
  })
